import messages from "../languages/index";
let lang = localStorage.getItem("language");
export default {
  install(Vue) {
    //
    // LEGENDAS GLOBAIS
    //
    (Vue.prototype.$legends = {
      // Legendas de Eventos
      // Utilizado em '/administrator/events/list'
      eventsActive(active) {
        const label = {
          1: messages[lang].notStarted,
          2: messages[lang].inProgress,
          3: messages[lang].finished,
          4: messages[lang].canceled,
          5: messages[lang].didPostponed,
          6: messages[lang].interrupted,
          7: messages[lang].abandoned,
          9: messages[lang].closeToStart
        };
        return label[active];
      }
    }),
      // Use to create resume on Historic bets listBets
      (Vue.prototype.$resume = {
        resumeBet: function(data) {
          let resume = data;
          let resumeBet = {
            prizeTotal: "",
            amountTotal: "",
            prizeNoPaid: "",
            prizePaid: ""
          };
          // Resume
          const listPrize = [];
          const listAmount = [];
          const listPrizePaid = [];
          const prizeNoPaid = [];

          resume.forEach(value => {
            const reducer = (accumulator, currentValue) =>
              accumulator + currentValue;

            listPrize.push(Number(value.prize));

            resumeBet.prizeTotal = listPrize.reduce(reducer).toFixed(2);
            listAmount.push(Number(value.amount));
            resumeBet.amountTotal = listAmount.reduce(reducer).toFixed(2);
            if (value.paid == "1") {
              listPrizePaid.push(Number(value.prize));
              resumeBet.prizePaid = listPrizePaid.reduce(reducer).toFixed(2);
            } else {
              prizeNoPaid.push(Number(value.prize));
              resumeBet.prizeNoPaid = prizeNoPaid.reduce(reducer).toFixed(2);
            }
          });

          return resumeBet;
        }
      }),
      // Decrypt URL in Image;
      (Vue.prototype.$constructURL = function(keyS3) {
        // Olds images
        if (keyS3.split("___").length < 2) return undefined;
        // Separa a Crypto
        var crypto = keyS3.split("___")[1].slice(0, -4);
        // Se caso a imagem não for uma URL crypto;
        if (crypto.length <= 13) return undefined;
        // Decrypt
        var bytes = Vue.CryptoJS.Rabbit.decrypt(crypto, "secretKey123");
        var decryptedData = bytes.toString(Vue.CryptoJS.enc.Utf8);
        return decryptedData;
      });

      // Handle Date Format
      (Vue.prototype.$handleDate = function(dateAndHour) {
        if (
          dateAndHour == null ||
          dateAndHour === "0000-00-00" ||
          dateAndHour === "0000-00-00 00:00:00" 
        ) {
          return { 
            date: "-",
            hour: "-",
            dateAndHour: "-"
          };
        } else {
          // Verifica se o back está enviando só uma data, ex.: 2024-05-05 == length 10
          // E complementa com um horário mockado, pois evita um bug do toLocaleDateString(),
          // onde a data é subtraída em 1 dia quando não existe a info do horário.
          const isOnlyDate =
            dateAndHour.length == 10 &&
            new Date(`${dateAndHour} 00:00:00`).toLocaleDateString();

          return { 
            date: isOnlyDate ? isOnlyDate : new Date(dateAndHour).toLocaleDateString(),
            hour: new Date(dateAndHour).toLocaleTimeString(),
            dateAndHour: new Date(dateAndHour).toLocaleString()
          };
        }
      });
  }
};
